<template>
  <div class="crpg-o-half-plan-common">
    <div class="top">
      <h1>
        <img
          :src="contentImage"
          class="top__logo"
        />
      </h1>
      <p class="catch newline">
        {{ content.catchcopy01 }}
      </p>
    </div>
    <div class="anchor-panel">
      <div class="anchor" v-for="(item, i) in anchorLinks" :key="i">
        <a :href="item.link" >{{ item.title }}</a>
      </div>
    </div>
    <div class="copy newline">
      {{ content.catchcopy02 }}
    </div>
    <a id="service" class="anchor_position"></a>
    <div class="menus">
      <MoleculesAboutEachPlan
        v-for="item in content.eachPlanDate"
        :key="item.title"
        :title="item.title"
        :eachplan="item.eachplan"
      />
    </div>
    <div class="benefit">
      <h2>
        {{ content.benefitTitle }}
      </h2>
      <a id="request" class="anchor_position"></a>
      <div class="link mb40">
        <h2 class="mb0">{{ $t("about.applicationRequestTitle") }}</h2>
        <ul>
          <li class="pamph"><a :href="requestDocURL">{{ content.primeMember }}</a></li>
        </ul>
      </div>
      <div class="bloc program">
        <h3>{{ content.specialPrograms }}</h3>
        <ul>
          <li class="l1">
            <span class="badge"
              >{{ content.great }}<br /><b>20</b
              >{{ content.tenThousandJPY }}<br />{{ content.equivalent }}</span
            >
            <h4>
              {{ content.freeInvite }}
            </h4>
            <p>
              {{ content.luxApartment }}<br />{{ content.enjoy }}
            </p>
          </li>
          <li class="l2">
            <span class="badge"
              >{{ content.great }}<br /><b>5</b
              >{{ content.tenThousandJPY }}<br />{{ content.equivalent }}</span
            >
            <h4>
              {{ content.freeMealInvite }}
            </h4>
            <p>
              {{ content.firstClassShop }}
            </p>
          </li>
          <li class="l3">
            <span class="badge"
              ><b>4</b>{{ content.tenThousandJPY }}<br />{{ content.equivalent }}</span
            >
            <h4>
              {{ content.invite4exchange }}
            </h4>
            <p>
              {{ content.oneFreeInvite }}
            </p>
          </li>
          <li class="l4">
            <span class="badge"
              ><b>3</b>{{ content.tenThousandJPY }}<br />{{ content.equivalent }}</span
            >
            <h4>
              {{ content.gift4anniversary }}
            </h4>
            <p>
              {{ content.delivery }}
            </p>
          </li>
        </ul>
      </div>

      <div class="about__coupons">
        <div class="bloc coupon">
          <h3>
            {{ content.freeCoupon }}
          </h3>
          <ul>
            <li class="l1">
              <span class="badge"
                ><b>80</b
                >{{ content.tenThousandJPY }}<br />{{ content.equivalent }}<br />{{ content.twoTimesPerYear }}</span
              >
              <h4>{{ content.coupons4gourmets }}</h4>
              <p>
                {{ content.mealDiscountCoupon }}
              </p>
            </li>
          </ul>
        </div>
        <div class="bloc coupon">
          <h3>
            {{ content.topRankedServices }}
          </h3>
          <ul>
            <li class="l1">
              <span class="badge"
                ><b>1.2</b>{{ content.tenThousandJPY }}<br />{{ content.equivalent }}</span
              >
              <p>
                {{ content.wideRange }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MoleculesAboutEachPlan from "@/components/molecules/about/EachPlan.vue";

import text from "@/assets/txt/about.json";
var obj = text;

export default {
  name: "FreeFoodContent",
  components: {
    MoleculesAboutEachPlan,
  },
  data() {
    return {
      content: obj,
      contentTopImage: require("@/assets/img/free_food.jpg"),
      contentTop: "アンティカ・オステリア・デル・ポンテ（東京/丸の内）",
      contentTopAlt: "アンティカ・オステリア・デル・ポンテ",
      contentTopText:
        "1年に1回、下記対象店舗の中からご希望のレストランを選び、1枚につき2名様までご利用いただけます。\n無料お食事ご招待券は、プレステージ・ゴールドへのご入会時、または更新時に1枚お送りします。",
      contentTopArea: "（東京/丸の内）",
      contentImageTitle: "【無料お食事ご招待券見本】",
      contentImageAlt: "無料お食事ご招待券見本",
      contentImage: require("@/assets/img/about_title.png"),
      anchorLinks : {
        service: {
          title:"サービス紹介",
          link: "#service"
        },
        request: {
          title: "資料請求",
          link: "#request"
        },
        entry: {
          title:"入会登録",
          link: "#entry"
        }
      },
      requestDocURL: process.env.VUE_APP_CRSD_URL + "inquiry"
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/organisms/about/aboutContent.scss";
</style>
